import { flagsFromMe } from '@codex/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { parseSecretsSearch } from '../../ledger/secrets-model.js';
import { SecretsPage } from '../../ledger/secrets-page.js';
import { NotFound } from '../../shell/not-found.js';

/**
 * `/secrets` (1.M-2 deliverable 1): guarded like every other authenticated route; `?state=` and
 * `?secret=<id>`. With the `ledger` flag off it is the not-found page.
 */
export const Route = createFileRoute('/secrets/')({
  staticData: { crumb: 'Secrets' },
  validateSearch: parseSecretsSearch,
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: SecretsRoute,
});

function SecretsRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const search = Route.useSearch();
  if (!flagsFromMe(me).ledger) return <NotFound />;
  return <SecretsPage search={search} />;
}
